<!-- 1001：客户登记 -->
<template>
     
    <el-card class="newtable"  style="width:96%;margin-left:auto;margin-right:auto">
        
        <div slot="header" class="clearfix">
            <span>当事人登记</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
            <el-button type='text' style="float: right; padding: 3px 0;color:black" >填表日期： {{form.createDate}}</el-button>
        </div>
    
<!-- :model="form" -->
        <el-form ref="form"   :model="form"     label-width="150px" class="formtable">
            <el-col :span="24"   >
                <div class="tag_item"  >客户信息 </div>
            </el-col>

              


            <el-form-item label="*当事人名称">
                <el-col :span="16"   >
                    <el-input :readonly="isReadOnly"  v-model="form.client_name"  @blur="CheckIsDup"  ></el-input>
                </el-col>

                <el-col :span="3" style="margin-left:20px"   >
                    <el-button size="mini" type="warning"  class="interest_conflict_style" @click.native="ClientConflictCheck">利冲检查</el-button> 
               </el-col>

                <el-col :span="3"    >
                    <el-button size="mini" type="success"  class="interest_conflict_style"  v-if="mode=='new' || mode=='edit' || mode=='rewrite'" @click.native="CheckIsDup(1)">是否重复检查</el-button> 
               </el-col>
                

                <el-col :span="5"  >
                    <p style="line-height:100%;color:red;padding-left:15px">  {{errMsg}}   </p>
                </el-col>

            </el-form-item>

            <el-form-item label="联系人">
                <el-col :span="10"  >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.client_contact"  ></el-input>
                </el-col>
                <!-- margin-left:20px; -->
                <el-col class="line" :span="3"  >  联系方式 </el-col>
                <el-col :span="10"   >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" v-model="form.client_phone"  ></el-input>
                
                </el-col>
            
            </el-form-item>

            <el-form-item label="联系地址">
                <el-col :span="23"  >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" v-model="form.client_address"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="是否是自然人">
                <!-- <el-switch v-model="form.isPerson"></el-switch> -->

                <el-col :span="10">
                    <!-- <el-input v-model="form.contactman"  ></el-input> -->
                    <el-switch :disabled="mode!='new' && mode!='edit'  && mode!='rewrite' " @change="CheckIsDup"  v-model="form.client_isPerson"></el-switch>
                </el-col>
                <!-- style=" text-align:right;padding-right:10px" -->
                <el-col class="line" :span="3"  v-if="form.client_isPerson">  *身份证号 </el-col>
                <el-col :span="10"  v-if="form.client_isPerson">
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.client_identity"   @blur="CheckIsDup"></el-input>
                
                </el-col>



            </el-form-item>

            <el-form-item label="备注">
                <!-- <el-input v-model="form.remarks"></el-input> -->
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    :placeholder="isReadOnly?'':'请输入内容'"
                    v-model="form.remarks_0">
                </el-input>
                </el-col>
            </el-form-item>


            <!-- <el-divider content-position="center">开票信息</el-divider> -->

            <el-col :span="24"   >
                <div class="tag_item"  > 开票信息 </div>
            </el-col>

            <el-form-item label="纳税人识别号">
                <el-col :span="23" >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.invoice.identification"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="开户行">
                

                <el-col :span="10">
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"  v-model="form.invoice.bank"  ></el-input>
                
                </el-col>
                <el-col class="line" :span="3"  >账户</el-col>
                <el-col :span="10"  >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" v-model="form.invoice.account"  ></el-input>
                
                </el-col>



            </el-form-item>

            <el-form-item label="开票电话">
                <el-col :span="23" >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" v-model="form.invoice.phone"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="单位地址">
                <el-col :span="23" >
                    <el-input :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'" v-model="form.invoice.address"></el-input>
                </el-col>
            </el-form-item>

            <!-- <el-divider content-position="center">备注</el-divider> -->

            <el-form-item label="备注">
             
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :readonly="mode!='new'&&mode!='edit'&&mode!='rewrite'"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remarks">
                </el-input>
                </el-col>
            </el-form-item>

            <el-form-item v-if="this.mode=='new' || this.mode=='edit' || this.mode=='rewrite'   ">
                <el-col :span="11" >
                    <el-button type="primary" @click="NewFormSubmit" style="margin:auto;width:150px">提交</el-button>
                    <!-- <el-button style="margin:auto">取消</el-button> -->
                </el-col>

                <el-col :span="11" >
                    <!-- <el-button type="primary" @click="onSubmit" style="margin:auto">立即创建</el-button> -->
                    <el-button style="margin:auto;width:150px"   @click="CancelForm" >取消</el-button>
                </el-col>


            </el-form-item>  

    
            <el-drawer
            title="可能的利冲对象(最多显示前20)"
            :visible.sync="int_drawer"
            :with-header="true"
            size='800px'
            >
            <div style="width:100%;height:40px;display:flex;justify-content:flex-end;padding-right:60px">  
                
          
                <el-radio-group v-model="client_conflict_check" @change="ChangeClientConflictCheck">
                    <el-radio label="all">不区分自然人</el-radio>
                    <el-radio :label="true">自然人</el-radio>
                    <el-radio :label="false">非自然人</el-radio>
                </el-radio-group>
            </div>
            <!-- <span>我来啦!</span> -->
                <el-table 
                        :data="conflict_list"
                        @row-click="handleCheck"
                        style="width: 95%;min-height:700px">
                        <el-table-column
                            label="编号"
                            width="50"
                            type="index">
                            <!-- {{index}} -->
                        </el-table-column>
                        <el-table-column
                            prop="form.case_name"
                            label="案件名称"
                            width="140">
                        </el-table-column>
 

                        <el-table-column
                            label="创建日期"
                            width="140">
                            <template slot-scope="scope">
                                <span>
                                    {{timestampToTime(scope.row.createtime)  }}
                                </span>
    
                            </template>  
                        </el-table-column>

                        <el-table-column
                            prop="form.oppositeinfo[0].opposite_name"
                            label="对方当事人名称"
                            width="140">
                        </el-table-column>

                        <el-table-column
                            label="是否自然人"
                            width="120">
                            <template slot-scope="scope">
                                <span>
                                    {{scope.row.form.oppositeinfo[0].opposite_isPerson? '是':'否' }}
                                </span>
    
                            </template>  
                        </el-table-column>

                        <el-table-column
                            prop="form.oppositeinfo[0].opposite_identity"
                            label="身份标识"
                            width="160">
                        </el-table-column>
             

         

     
                    </el-table>



            </el-drawer>


        
        </el-form>


    

    </el-card>

</template>

<script>
    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

  
    import affix_box from '@/components/oa/functions/affix_box.vue'


	export default {
        name: 'template_1001',
        props: {
            form:Object,
            mode:String,
        },
        components: { 
            affix_box
        },
        data() {
			return {
                isReadOnly:false,
                errMsg:'',

                block:false,
                block_msg:'',
       
                int_drawer:false,
                conflict_list:[],
                client_conflict_check:'all'

			}
        },
        mounted() {
        //    console.log('template_id  1001 start mode:',this.mode)  //还有个detail 模式
      

            let t=setInterval(()=>{
                if(this.mode){
                    clearInterval(t)
                    if(this.mode=='new'){
                        this.form.client_isPerson=false
                    } 
                    if(this.mode!='new' && this.mode!='edit' && this.mode!='rewrite'){
                        this.isReadOnly=true
                    }

                   

                }


            },500)

           

            // console.log("this.form:",this.form)
            // console.log("this.isReadOnly:",this.isReadOnly)



            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        methods: {

            timestampToTime(timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D ;  //+ h + m + s
            },

            NewFormSubmit(){
                let obj={"template_id":"1001" , "sheet_name":"客户登记表","block":this.block,"block_msg":this.block_msg }
                console.log('1001 NewFormSubmit emit')
                console.log("this.$refs[formName]:",this.$refs['form'])
                this.$emit('SubmitNewForm',obj); 
            },
            CancelForm(){
                window.close();

            },


            CheckIsDup(isMsg=0){
                console.log("CheckIsClientDup")
                if(this.mode!='new' && this.mode!='edit' && this.mode!='rewrite'){
                    return
                }

                var that=this
                var data= { 
                    whattodo: "CheckIsClientDup",
                    client_name:this.form.client_name,
                    mode:this.mode,
                    _id:this.$route.params.id ,
                    client_isPerson:this.form.client_isPerson,
                    client_identity:this.form.client_identity ||''
                }
                that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        console.log('result:',result)
                        if(result.status=='1'){
                            that.errMsg='该客户已被登记'

                            that.block=true
                            that.block_msg='该客户已被登记'
                            if(isMsg==1){
                                
                               that.$message.error('该客户已被登记!');
                            }

                        }else{
                            that.errMsg='客户名称可登记'
                            that.block=false
                            that.block_msg=''
                            if(isMsg==1){
                                
                                that.$message({
                                    type: 'success',
                                    message: '客户名称可登记!'
                                });
                            }

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });

            },


            
            ChangeClientConflictCheck(value){
                window.console.log('value:',value);
                this.ClientConflictCheck(value)
            },
      
            
            ClientConflictCheck(isPerson='all'){
                console.log('-----ClientConflictCheck----')
                var that=this

                var data= { 
                    whattodo: "ClientConflictCheck",
                    client_name:this.form.client_name,
                    // oppositeinfo: arr ,//this.form.oppositeinfo,
                    // mode:this.mode,
                    _id:this.$route.params.id ,
                    client_isPerson:isPerson,
                    client_identity:this.form.client_identity ||''
                }
                // that.isallset=false
                this.axios.post(this.$root.rootUrl+'oa',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        console.log('result:',result)
                        if(result.status=='ok'){
                            let data=result.data
                            if (data.length==0){
                                that.$message({
                                    message: '在对方当事人中未找到冲突对象',
                                    type: 'success'
                                });
                              
                                that.conflict_list=[]
                               
                            }else{
                                that.int_drawer=true
                                that.conflict_list=data

                                console.log("that.conflict_list:",that.conflict_list)
                            }
 
                        }else if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                        }
                        // if(result.status=='1'){
                        //     that.errMsg='该客户已被登记'

                        //     that.block=true
                        //     that.block_msg='该客户已被登记'

                        // }else{
                        //     that.errMsg='客户名称可登记'
                        //     that.block=false
                        //     that.block_msg=''
                        // }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });
            },

            handleCheck(row){
                console.log("row:",row)

                let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id: '1002' ,  id: row._id} });
                window.open(routeData.href, '_blank'); 

            }
          


             

        }
	}
	
</script>

<style>
/* .el-menu{
    color:black;
} */

 
 

</style>
